import {
  buildUrlWithParameters,
  isUrlInternal,
} from '../../../../utils/url-utils/urlUtils';

export function getCommentUrl(url: string, accessPremium: boolean) {
  const internalUrl = isUrlInternal(url);
  let commentUrl = url;
  if (internalUrl && accessPremium) {
    commentUrl = buildUrlWithParameters(url, {
      source: 'excerpt_results_comment',
    });
  }
  return commentUrl;
}
